import { onMounted, ref, reactive } from 'vue';
import BannerSwiper from '@/components/BannerSwiper/index.vue';
import { getHomeTopMediaReportsList_url } from "@/api"; //引入发送请求获取数据的方法

import Report from '@/pages/mediaDetails/components/report.vue';
export default {
  components: {
    BannerSwiper: BannerSwiper,
    Report: Report
  },
  name: 'Index',
  setup: function setup() {
    var bannerList = reactive([{
      id: 0,
      // imageUrl: require('@/pages/MediaReport/image/banner-mediaReport.png'),
      imageUrl: require('../MediaReport/image/1-1.jpg')
    }]);
    return {
      bannerList: bannerList
    };
  }
};